import React, { Component } from 'react'
import { connect } from 'react-redux'

import { loadLots, addLot } from '../actions'
import WindowSpinner from './WindowSpinner'
import Lotline from './Detections/LotLine'
// import LotHeader from './Detections/LotHeader'

const initialState = {
  newLotname: '',
  newExtraordinary: '0',
  showStraordinary: true,
  showExtraordinary: true
}

class Detections extends Component {
  constructor () {
    super()
    this.state = initialState
  }

  addIsDisabled () {
    const n = this.state.newLotname
    const lots = this.props.detections.lots
    return (n.length === 0 || (lots || []).filter(x => x.name.toLowerCase() === n.toLowerCase()).length > 0)
  }

  addLot () {
    this.props.addLot({ name: this.state.newLotname, extraordinary: this.state.newExtraordinary }, this.setState({ ...initialState }))
  }

  componentDidMount () {
    if (this.props.detections.lots === null) {
      this.props.loadLots()
    }
  }

  render () {
    const { lots, loading } = this.props.detections
    const s = this.state
    return (
      <div className="full-page">
        <button
          className="lnk-det-refresh"
          onClick={() => this.props.loadLots()}
        >
          <i className="fas fa-sync-alt"></i>
        </button>
        <h1>i tuoi lotti</h1>
        <ul className="ul-detections">
          <li className="field">
            <input
              type="text"
              value={this.state.newLotname}
              onChange={(event) => this.setState({ newLotname: event.target.value })}
              placeholder="Aggiungi lotto" />
          </li>
          <li>
            <select
              onChange={e => this.setState({ newExtraordinary: e.target.value })}
              value={this.state.newExtraordinary}
            >
              <option value="0">Manutenzione Ordinaria</option>
              <option value="1">Manutenzione Straordinaria</option>
            </select>
          </li>
          <li className="btn">
            <button
              className="lnk-edit-lot"
              onClick={() => this.addLot()}
              disabled={this.addIsDisabled()}
            >
              aggiungi
            </button>
          </li>
        </ul>
        {
          (lots || []).filter(x => x.id === 0).map((l, index) => {
            return (
              <Lotline
                key={index}
                l={l}
              />
            )
          })
        }
        <h2 className="rltv caret" onClick={() => this.setState({ showExtraordinary: !s.showExtraordinary })}>
          manutenzione straordinaria
          <i className={'fas fa-caret-' + (s.showExtraordinary ? 'up' : 'down')}></i>
        </h2>
        {
          s.showExtraordinary && (
            <>
              {
                (lots || []).filter(x => x.extraordinary === 1 && x.id !== 0).map((l, index) => {
                  return (
                    <Lotline
                      key={index}
                      l={l}
                      lots={lots}
                    />
                  )
                })
              }
            </>
          )
        }
        <h2 className="rltv caret" onClick={() => this.setState({ showStraordinary: !s.showStraordinary })}>
          manutenzione ordinaria
          <i className={'fas fa-caret-' + (s.showStraordinary ? 'up' : 'down')}></i>
        </h2>
        {
          s.showStraordinary && (
            <>
              {
                (lots || []).filter(x => x.extraordinary === 0 && x.id !== 0).map((l, index) => {
                  return (
                    <Lotline
                      key={index}
                      l={l}
                      lots={lots}
                    />
                  )
                })
              }
            </>
          )
        }
        {
          loading && (
            <WindowSpinner />
          )
        }
      </div>
    )
  }
}

function mapStateToProps (state) {
  return state
}

export default connect(mapStateToProps, { loadLots, addLot })(Detections)
